module.exports = __webpack_public_path__ + "img/purchase_banner2.135604d5.png";